// extracted by mini-css-extract-plugin
module.exports = {"bold":"src-components-BudgetBuilder-Setup-CopyToFrom-styles___bold"};